export default __webpack_public_path__ + "static/media/giftIcon.cb8898c0.svg";